import { render, staticRenderFns } from "./TransferStock.vue?vue&type=template&id=70414517&"
import script from "./TransferStock.vue?vue&type=script&lang=js&"
export * from "./TransferStock.vue?vue&type=script&lang=js&"
import style0 from "./TransferStock.vue?vue&type=style&index=0&id=70414517&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports